<template>
  <div>
    <Menu :open-names="['1', '2', '3']" class="layout-menu-style">
      <Submenu name="1">
        <template slot="title">
          <Icon type="ios-people"/>
          代理商
        </template>
        <MenuItem name="orderSummary" to="/order-summary">消费统计</MenuItem>
      </Submenu>
      <Submenu name="data_monitor" v-if="vendorInfo.level === 0">
        <template slot="title">
          <Icon type="ios-stats"/>
          数据监控
        </template>
        <MenuItem name="data_monitor_device_data" to="/device-summary-data">设备数据汇总</MenuItem>
      </Submenu>
      <Submenu name="2" v-if="vendorInfo.level === 0">
        <template slot="title">
          <Icon type="ios-stats"/>
          平台数据
        </template>
        <MenuItem name="2-3" to="/feedback">反馈管理</MenuItem>
        <MenuItem name="moneySummary" to="/money-summary">财务报表</MenuItem>
        <MenuItem name="withdraw" to="/transfer-mgnt">提现管理</MenuItem>
      </Submenu>
      <Submenu name="3" v-if="vendorInfo.level === 0">
        <template slot="title">
          <Icon type="ios-settings"/>
          平台配置
        </template>
        <MenuItem name="3-1" to="/device">设备管理</MenuItem>
        <MenuItem name="3-2" to="/service-package">氧疗套餐配置</MenuItem>
        <MenuItem name="vendorMgnt" to="/vendor">代理商管理</MenuItem>
        <MenuItem name="3-4" to="/recharge-package">充值套餐配置</MenuItem>
        <MenuItem name="3-5" to="/brand">品牌管理</MenuItem>
      </Submenu>
    </Menu>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        vendorInfo: {},
        menus: []
      }
    },
    mounted() {
      this.$http.get('/vendor/myVendorInfo').then((resp) => {
        if (resp.status == 1) {
          this.vendorInfo = resp.data;
        }
      })
    },
  }
</script>



// WEBPACK FOOTER //
// LeftMenu.vue?48e1eb30